import { create } from "zustand";

export const useConfigStore = create((set) => ({
  config: null,
  setConfig: (config) => set({ config }),
  reset: () => set({ config: null }),
}));
